import * as React from 'react';
import styles from './marketing-body.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

MarketingBody.defaultProps = {
    as: 'p',
};

export function MarketingBody({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['body']}>{children}</Tag>;
}
